import { useEffect, useState } from "react";

import { AddContactModalStep, AddContactType } from "../model/addContact.types";

type UseAddContactModalControllerParams = {
  isOpen: boolean;
  closeModal: () => void;
  /** Open straight on this form instead of "Choose contact type". */
  initialType?: AddContactType;
};

export const useAddContactModalController = ({
  isOpen,
  closeModal,
  initialType,
}: UseAddContactModalControllerParams) => {
  const [step, setStep] = useState<AddContactModalStep>(
    initialType ?? "select",
  );

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setStep(initialType ?? "select");
  }, [isOpen, initialType]);

  const closeAddContactModal = () => {
    setStep("select");
    closeModal();
  };

  const returnToSelectStep = () => {
    setStep("select");
  };

  const openContactForm = (type: AddContactType) => {
    setStep(type);
  };

  return {
    step,
    closeAddContactModal,
    returnToSelectStep,
    openContactForm,
  };
};
